import React from 'react'
import ReactDOM from 'react-dom/client'
import {BrowserRouter} from 'react-router-dom'
import App from '@app/App.jsx'
import {AuthProvider} from '@modules/auth/AuthContext.jsx'
import 'bootstrap/dist/css/bootstrap.min.css'

import 'antd/dist/reset.css'

ReactDOM.createRoot(document.getElementById('root')).render(
	<React.StrictMode>
		<BrowserRouter>
			<AuthProvider>
				<App/>
			</AuthProvider>
		</BrowserRouter>
	</React.StrictMode>
)
